import { apiFetch } from "./http";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

export async function fetchCategories() {
  const res = await apiFetch(`${API_URL}/emails/categories`);
  if (!res.ok) throw new Error("Failed to fetch categories");
  return res.json();
}

export async function fetchEmails(page = 1, pageSize = 10, options = {}) {
  const forceSync = options.forceSync ? "&forceSync=1" : "";
  const res = await apiFetch(`${API_URL}/emails?page=${page}&pageSize=${pageSize}${forceSync}`);
  if (!res.ok) throw new Error("Failed to fetch emails");
  return res.json();
}

export async function fetchConversation(emailId) {
  const res = await apiFetch(`${API_URL}/emails/${emailId}/conversation`);
  if (!res.ok) throw new Error("Failed to fetch conversation");
  return res.json();
}

export async function sendEmail(payload) {
  const res = await apiFetch(`${API_URL}/emails/send`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to send email");
  }

  return res.json();
}

export async function fetchCannedReply({ subject, body, language }) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 30000);

  try {
    const res = await apiFetch(`${API_URL}/emails/canned-reply-preview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ subject, body, language }),
      signal: controller.signal,
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.details || data.error || `Suggestion service failed (${res.status})`);
    }
    return res.json();
  } finally {
    clearTimeout(timeoutId);
  }
}

export async function replyToEmail(payload) {
  const res = await apiFetch(`${API_URL}/emails/reply`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to send reply");
  }

  return res.json();
}

/**
 * Fetch the body for a single email from the backend.
 * Backend serves from DB cache (<20 ms) or fetches via the open IDLE
 * connection (~300 ms) so this feels instant in almost all cases.
 */
export async function fetchEmailBody(emailId) {
  const res = await apiFetch(`${API_URL}/emails/${emailId}/body`);
  if (!res.ok) throw new Error("Failed to fetch body");
  const data = await res.json();
  return data.body || "";
}

export async function fetchAttachments(emailId) {
  const res = await apiFetch(`${API_URL}/emails/${emailId}/attachments`);
  if (!res.ok) throw new Error("Failed to fetch attachments");
  const data = await res.json();
  return data.attachments || [];
}